(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", function () {
      let target = document.getElementById(this.dataset.acc);

      document.querySelectorAll(".accordion-body").forEach(body => {
        if (body !== target) body.style.maxHeight = null;
      });
      document.querySelectorAll(".acc-icon").forEach(icon => {
        if (icon !== this.querySelector(".acc-icon")) icon.textContent = "+";
      });

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
        this.querySelector(".acc-icon").textContent = "+";
      } else {
        target.style.maxHeight = target.scrollHeight + "px";
        this.querySelector(".acc-icon").textContent = "-";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
